import { useCallback, useEffect, useState } from "react";
import Logger from "../../../services/Logger";
import AdminWordWheelBoardService from "./AdminWordWheelBoardService";

export const useWordWheelPuzzleData = (id, refresh = 0) => {
    const [tpl, setTpl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTpl = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await AdminWordWheelBoardService.requestTemplate(id);
            setTpl(result);
        } catch (err) {
            Logger.error("Error fetching word wheel template:", err);
            setError("Failed to fetch puzzle data. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [id]);

    const refetch = useCallback(async () => {
        if (id) {
            await fetchTpl();
        }
    }, [id, fetchTpl]);

    useEffect(() => {
        if (id) {
            fetchTpl();
        } else {
            setTpl(null);
            setLoading(false);
            setError(null);
        }
    }, [id, refresh, fetchTpl]);

    return { tpl, loading, error, refetch };
};
